import { createSelector } from 'reselect';

const getUpcomingEventLoading = state => state.events.upcomingEvents.loading;
const getPastEventLoading = state => state.events.pastEvents.loading;
const getUpcomingOpenEventLoading = state =>
  state.events.upcomingOpenEvents.loading;

export const isLoadingEvents = createSelector(
  [getUpcomingEventLoading, getPastEventLoading, getUpcomingOpenEventLoading],
  (upcomingEventLoading, pastEventLoading, upcomingOpenEventLoading) =>
    upcomingEventLoading && pastEventLoading && upcomingOpenEventLoading,
);
